import * as React from 'react';

function Snowboarding(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.835 4.164a3.98 3.98 0 01-.44 6.008 44.782 44.782 0 00-4.948 4.271 44.782 44.782 0 00-4.271 4.95 3.978 3.978 0 01-6.01.441 3.98 3.98 0 01.442-6.01 44.772 44.772 0 004.949-4.271 44.775 44.775 0 004.27-4.95 3.98 3.98 0 016.007-.438h.001zm-7.834 8.813l-.978-.979-.095-.09a2.076 2.076 0 00-3.45 1.559c0 .55.219 1.079.608 1.468l.978.978.095.09A2.077 2.077 0 0012 12.976zm-.979.979a.693.693 0 01-.98.98l-.977-.979-.058-.066a.692.692 0 011.036-.913l.98.978zm4.896-4.896l-.978-.978-.096-.09a2.076 2.076 0 00-2.842 3.027l.978.979.095.09a2.076 2.076 0 002.843-3.027V9.06zm-.98.979a.692.692 0 11-.98.98l-.978-.979-.057-.065a.692.692 0 011.036-.914l.978.978z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Snowboarding;
